import { useState, useContext } from "react";
import { Stack, Typography, Tooltip, Box, IconButton } from "@mui/material";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { useMutation } from "@apollo/client";
//import from project
import "../../../Style/actionstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_EXAM } from "../../../Schema/ExamType";
import ExamForm from "./ExamForm";
import ViewExam from "./ViewExam";
import DialogDelete from "../../../Utils/DialogDelete";

export default function ExamRow({ data, row, classId, setRefetch, language }) {
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  //Modal view
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [deleteExam] = useMutation(DELETE_EXAM, {
    onCompleted: ({ deleteExam }) => {
      setLoading(false);
      if (deleteExam?.isSuccess === true) {
        setAlert(true, "success", deleteExam?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteExam?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    deleteExam({
      variables: {
        id: row?._id,
        arrayId: data?._id,
      },
    });
  };

  return (
    <Stack direction="row" sx={{ width: "100%" }}>
      <Stack direction="column" justifyContent="center" sx={{ width: "20%" }}>
        <Typography>
          {language === "en"
            ? data?.subjectId?.enName
            : data?.subjectId?.khName}
        </Typography>
      </Stack>

      <Stack direction="column" justifyContent="center" sx={{ width: "50%" }}>
        <Typography>{data?.exercise}</Typography>
      </Stack>

      <Stack direction="column" justifyContent="center" sx={{ width: "10%" }}>
        <Typography>{data?.score}</Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="right"
        spacing={1}
        sx={{ width: "20%" }}
      >
        <Tooltip title={t("view")} placement="top">
          <IconButton onClick={handleOpenView}>
            <Box className="view-container">
              <IoMdEye className="view-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        {openView && (
          <ViewExam
            open={openView}
            editData={data}
            row={row}
            handleClose={handleCloseView}
            language={language}
          />
        )}

        {openEdit && (
          <ExamForm
            open={openEdit}
            row={row}
            classId={classId}
            setRefetch={setRefetch}
            handleClose={handleCloseEdit}
            editData={data}
            dialogTitle="Update"
          />
        )}

        {openDel && (
          <DialogDelete
            open={openDel}
            handleClose={handleCloseDel}
            loading={loading}
            deleteTitle={t("modal_title_delete_exam")}
            handleDelete={handleDelete}
          />
        )}
      </Stack>
    </Stack>
  );
}
